import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AddSomeoneElseDto } from '../../../common/dtos/add-someone-else.dto';
import {
    CreateInvitationsDto,
    CreateInvitationsResponseDto,
} from '../../interfaces/create-invitations.interface';

@Injectable({
    providedIn: 'root',
})
export class AddSomeoneElseService {
    private readonly httpClient = inject(HttpClient);


    /**
     * Submits information for a new grantee and generates a unique PIN.
     * 
     * @param addSomeoneElseDto - The DTO containing the new grantee's information
     * @returns Observable<{ uniquePin: string }> - An observable containing the generated unique PIN
     * 
     * @remarks
     * This API call is used in the Grant Access Flow (GAF) when adding someone who doesn't
     * have an existing Vanguard account. The returned PIN is used to invite the new grantee.
     */
    gatherPinAndDto(addSomeoneElseDto: AddSomeoneElseDto): Observable<{ uniquePin: string }> {
        return this.httpClient.post<{ uniquePin: string }>(
            `${environment.ZCI_API_BASE_URL}${environment.ZCI_API_ENDPOINTS.ADD_SOMEONE_ELSE}`,
            addSomeoneElseDto,
        );
    }

    /**
     * Submits information for a new grantee across multiple accounts and generates a unique PIN.
     *
     * @param createInvitationsDto - The DTO containing the new grantee's information and target accounts
     * @returns Observable<CreateInvitationsResponseDto> - An observable containing the generated PIN and succeeded accounts
     *
     * @remarks
     * This API call is used in the multi-account Grant Access Flow (GAF) when adding someone who doesn't
     * have an existing Vanguard account. The returned PIN is used to invite the new grantee.
     */
    gatherPinAndDtoMultiAccount(
        createInvitationsDto: CreateInvitationsDto,
    ): Observable<CreateInvitationsResponseDto> {
        return this.httpClient.post<CreateInvitationsResponseDto>(
            `${environment.ZCI_API_BASE_URL}${environment.ZCI_API_ENDPOINTS.ADD_SOMEONE_ELSE_MULTI}`,
            createInvitationsDto,
        );
    }
}
